import { useRef, useEffect, useState } from 'react';

import Social from '../socials/social.component';

import { Button } from 'antd'; 

import "./contact-box.styles.scss";

const ContactFormBox = ({whatContactForm}) => {
	const contactRef = useRef(null); // Ref for Contact section

	const [animate, setAnimate] = useState(true);

    useEffect(() => {
        // Remove bounce animation after 3 seconds
        const timer = setTimeout(() => setAnimate(false), 3000);
        return () => clearTimeout(timer);
    }, []);

	const scrollToContact = () => {
		// Smoothly scroll to the Contact section
		if (contactRef.current) {
			contactRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	};

	// Check for scroll flag in sessionStorage on load
	useEffect(() => {
		if (sessionStorage.getItem('scrollToContact') === 'true') {
			scrollToContact();
			sessionStorage.removeItem('scrollToContact'); // Reset the flag after scrolling
		}
	}, []);

	// Handler to set scroll flag and refresh page
	const refreshAndScroll = () => {
		sessionStorage.setItem('scrollToContact', 'true'); // Set flag to scroll after refresh
		window.location.reload(); // Refresh the page
	};

	return (
        <div className='contact-box-container'>
			<h2>Enter Info Below to Get Started</h2>

			{/* Contact Section with ref */}
            <div className='contact-box' ref={contactRef}>
				<span
					style={{
						width: '100%',
						paddingBottom: '1rem',
						display: 'flex',
						justifyContent: 'center'
					}}
				>
					<Social />
				</span>
                {whatContactForm}
            </div>

            {/* Refresh and scroll button above Contact section */}
            <Button 
				onClick={refreshAndScroll} 
				className={`refresh-scroll-btn ${animate ? 'bounce' : ''}`}
				block={true}
				style={{
					color: 'white',
					backgroundColor: 'green',
					fontFamily: 'Georgia, serif',
					fontSize: `${window.screen.width <= 1000 ? '1.1em' : '2em'}`,
					padding: '0.5rem 1rem',
					minWidth: 'max-content',
					height: 'auto',
					alignSelf: 'center'
				}}
			>
				Message Box Not Showing? <bold> CLICK ME!</bold>
			</Button>

        </div>
	);
}

export default ContactFormBox;
